import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'ng-uikit-pro-standard';
import { AuthModalComponent } from 'src/app/auth/components/auth-modal/auth-modal.component';
import { encryptStorage } from 'src/app/auth/utils/storage';
import { InstituicaoRegime } from '../../models/instituicoes-regime.model';
import { CodigoTransacaoService } from '../../services/codigo-transacao.service';
import { InstituicoesRegimeService } from '../../services/instituicoes-regime.service';
import { showError } from '../../utils/functions/notification.function';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  p: number = 1
  dataAtual = ""
  date = new Date()

  slides: any[] = [[]]

  showOrdinaria: boolean = true
  tableDataCard : InstituicaoRegime[] = []
  exibirCards: boolean = true 

  constructor(private regimeService: InstituicoesRegimeService, private codigo: CodigoTransacaoService) { }

  ngOnInit(): void {
    let codigoTransacao = this.codigo.getUniqueId(5)
    this.listarInstituicoes(codigoTransacao)
    this.dataAtual = `${this.formataData(this.date.getDate())}/${this.formataData(this.date.getMonth())}/${this.date.getFullYear()}`
  }

   formataData(numero){
    if (numero <= 9)
        return "0" + numero;
    else
        return numero;
}

  listarInstituicoes(param){
    this.regimeService.instituiçõesRegime(param).subscribe(
    res => this.tableDataCard = res["data"],
    e=> console.log(e,"Houve erros ao listar as instituições em regime especial."),
    () =>  this.exibirCards = this.tableDataCard.length == 0 ? false : true
    )
  }

  
}
